import React from "react";
import shortid from "shortid";
import { withRouter } from "react-router-dom";
import TestimonialBox from "./TestimonialBox";
import { connect } from "react-redux";
import Loader from "../../../Common/Loader/";
import { getReviewsToShow } from "../../../Common/CommonMethods";

const TestimonialPremium = (props) => {
  return (
    <React.Fragment>
      {!!props.vendorTestimonials?.reviews?.length ||
      !props.vendorTestimonials?.filterData ? (
        <div className="testimonial_reviews">
          {props.vendorTestimonials?.featured_reviews?.length > 0 ||
          props.vendorTestimonials?.reviews?.length > 0 ? (
            <React.Fragment>
              <ul>
                {getReviewsToShow(
                  [...props.vendorTestimonials?.reviews],
                  props.vendorTestimonials?.pagination?.per_page
                ).map((review) => (
                  <TestimonialBox
                    key={shortid.generate()}
                    {...review}
                    pathname={props.location.pathname}
                    isLeadGenPopUp={props.vendorProfile?.is_lead_generate_popup}
                    totalRefCount={
                      props.vendorCommon?.casestudy_count
                        ? props.vendorCommon?.casestudy_count +
                          props.vendorCommon?.testimonial_count +
                          props.vendorCommon?.video_count
                        : 0
                    }
                    companyId={
                      props.vendorCommon?.company_id
                        ? props.vendorCommon?.company_id
                        : -1
                    }
                    linkedInUrl={props.vendorTestimonials?.linkedin_signin_url}
                  />
                ))}
              </ul>
            </React.Fragment>
          ) : (
            <Loader />
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorTestimonials: state.vendorTestimonials,
    vendorCommon: state.vendorCommon,
    vendorProfile: state.vendorProfile,
    isEnterpriseLogin: state.homePage.isEnterpriseLogin,
  };
};

const withRouterTestimonialPremium = withRouter(TestimonialPremium);

export default connect(mapStateToProps)(withRouterTestimonialPremium);
